export const routesData = [{
  title: 'Dashboard',
  name: 'dashboard',
  route: 'dashboard',
  icon: 'dashboard-icon',
}, {
  title: 'Products',
  name: 'my-products',
  route: 'my-products',
  icon: 'product-icon',
  allow: ['admin', 'catalog-view', 'catalog-edit', 'repository', 'fitments']
}, {
  title: 'Fitments',
  name: 'fitments',
  route: 'fitments',
  icon: 'my-fitments-icon',
  allow: ['admin', 'fitments']
}, {
  title: 'Digital Assets',
  name: 'digital-assets',
  route: 'digital-assets',
  icon: 'digital-assets-icon',
  allow: ['admin', 'dam-view', 'dam-edit', 'repository']
}, {
  title: 'Reports',
  name: 'reports',
  route: 'reports',
  icon: 'reports-icon',
  allow: ['admin'],
}, {
  title: 'Receivers',
  name: 'receivers',
  route: 'receivers',
  icon: 'receivers-icon',
}];
